/**
 * Created by elad on 20 נובמבר 2016.
 */

import config from "src/config/";
import store from "src/store";

function createGetters () {
	const getters = {};
	Object.keys(config).forEach((key) => {
		getters[key + "Config"] = (state) => {
			return state[key];
		};
	});
	return getters;
}

export const types = {
	SET: "set/config",
};

export function Config (key, value) {
	store.commit(types.SET, { key, value });
}

export default {

	state: config,
	getters: createGetters(),
	mutations: {
		[types.SET] (state, { key, value }) {
			let object = state;
			const stack = key.split(".");
			while (stack.length > 1) {
				object = object[stack.shift()];
			}
			object[stack.shift()] = value;
		},

	},
	actions: {},
	types: types,
};
